/**
 * Loading
 */

const $ = window.jQuery;

function show(message) {
  if (message) {
    $('.loading-global').find('.loading-message').text(message);
    $('.loading-global').addClass('has-message');
  }
  $('.loading-global').addClass('is-visible');
}

function hide() {
  $('.loading-global').removeClass('is-visible');
  setTimeout(() => {
    $('.loading-global').find('.loading-message').text('');
    $('.loading-global').attr('class', 'loading-container loading-global');
  }, 300);
}

// Exports
export { show, hide };
